import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import './AccountList.css';

import { accountsLoading, loadAccountsByUser, selectAccounts } from "../../features/manageAccounts/accountsSlice";

import AccountCard from "../../components/accountCard/AccountCard";
import { isLoggedIn, selectToken } from "../../features/login/loginSlice";
import { selectUser } from "../../features/home/userSlice";

export default function AccountList() {
    const dispatch = useDispatch();

    const accounts = useSelector(selectAccounts);
    const loadingAccounts = useSelector(accountsLoading);
    const loggedIn = useSelector(isLoggedIn);

    const userInfo = useSelector(selectUser);
    const username = userInfo.username
    
    const token = useSelector(selectToken);

    useEffect(() => {
        if (loggedIn && username && token) {
            dispatch(loadAccountsByUser({username: username, token: token}));
        }
    }, [loggedIn, username, token, dispatch])
    
    return (
        <section className="account-list">
            {loadingAccounts ? <h2>Loading Accounts...</h2> : 
                Object.values(accounts).map(account => <AccountCard account={account} key={account.accountId} accountId={account.accountId} />)
            }
            </section>
    )
}